<div mat-dialog-title>
  <h2>Copy Cards</h2>
</div>
<div mat-dialog-content>
  <p>The active question already has cards configured</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-flat-button color="primary" [mat-dialog-close]="'override'" cdkFocusInitial>Override</button>
</div>
